import React, { useContext } from 'react';

import { Navigate } from 'react-router-dom';

import { AuthContext } from '../../auth/AuthContext';

type PrivateRouteProps = {
  children: JSX.Element;
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }: PrivateRouteProps) => {
  const auth = useContext(AuthContext);

  return auth.isAuthenticated && auth.isAuthenticated() ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
